import InviteFormContainer from './InviteFormContainer';

export default InviteFormContainer;
